export const PERIZIE_GET = "PERIZIE_GET";
export const PERIZIE_GET_SUCCESS = "PERIZIE_GET_SUCCESS";